var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wishcard__editor",
      class: "wishcard__editor--" + _vm.card.size
    },
    [
      _c("div", { staticClass: "wishcard__field", style: _vm.bgStyles }, [
        _vm.showPlaceholder
          ? _c(
              "p",
              {
                staticClass: "wishcard__placeholder",
                style: _vm.placeholderStyle
              },
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("wishcard.placeholder") +
                        (_vm.isHandwritten ? " *" : "")
                    )
                  )
                ]),
                _c("br"),
                _vm._v(_vm._s(_vm.$t("wishcard.placeholder_note")) + "\n    ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("textarea", {
          ref: "textarea",
          staticClass: "wishcard__input",
          attrs: {
            name: "card_text",
            placeholder: _vm.showDefaultPlaceholder
              ? _vm.$t("wishcard.placeholder") +
                " " +
                _vm.$t("wishcard.placeholder_note")
              : null,
            rows: _vm.maxLines,
            "data-limit": "small"
          },
          domProps: { textContent: _vm._s(_vm.cardText) },
          on: {
            input: _vm.validate,
            focus: function($event) {
              _vm.focused = true
            },
            blur: function($event) {
              _vm.focused = false
            }
          }
        }),
        _vm._v(" "),
        _vm.showLayeredImage
          ? _c("div", {
              staticClass: "wishcard__layered-image",
              style: _vm.imageStyles
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.isHandwritten
        ? _c("p", {
            staticClass: "wishcard__handwritten-note",
            domProps: {
              textContent: _vm._s("* " + _vm.$t("wishcard.handwritten_note"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMaxLinesError
        ? _c("p", {
            staticClass: "wishcard__validation",
            domProps: {
              textContent: _vm._s(_vm.$t("wishcard.max_lines_error"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMaxLengthError
        ? _c("p", {
            staticClass: "wishcard__validation",
            domProps: {
              textContent: _vm._s(
                _vm.$t("wishcard.max_length", { maxLength: _vm.maxLength })
              )
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }